import React from 'react'
import {View, Text} from "@react-pdf/renderer";
import { insertPDFNewlines } from '../../../../../utils';

const TableRow = ({summary}) => {
  return (
    summary.job_order_meta_summary_quality.map((item, index) => (

    <View
    key={index}
    style={{
        flexDirection: "row",
        padding: "0px 10px"
    }}
>
    
    <View
        style={{
            width:"100%",
            flexDirection: "row"
        }}
    >
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "8%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* ITEM */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center"
                }}
            >
                {index+1}
            </Text>
            {/* ITEM */}

        </View>
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* CRITICAL */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center"
                }}
            >
                {item.quality_defect_details.critical_defect ? item.quality_defect_details.critical_defect : "-"}
            </Text>
            {/* CRITICAL */}
        </View>
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* MAJOR */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center"
                }}
            >
                {item.quality_defect_details.major_defect ? item.quality_defect_details.major_defect : "-"}
            </Text>
            {/* MAJOR */}
        </View>
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* MINOR */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center"
                }}
            >
                {item.quality_defect_details.minor_defect ? item.quality_defect_details.minor_defect : "-"}
            </Text>
            {/* MINOR */}

        </View>
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "12%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* NOTE */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center"
                }}
            >
                -
            </Text>
            {/* NOTE */}
        </View>
        <View
        style={{
            backgroundColor: "#fff",
            padding: "1px",
            width: "8%",
            borderWidth: "1px",
            borderTopWidth: "0",
            borderColor: "#000",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            {/* PIC */}
            <Text
                style={{
                    fontSize: "7px",
                    color: "#000",
                    textAlign: "center",
                    flexWrap: "wrap",
                    textOverflow: "ellipsis"
                }}
            >
                -
                {/* {insertPDFNewlines("Hello world this is me some_pic_123331.jpg", 10)} */}
            </Text>
            {/* PIC */}
        </View>
    </View>
</View>
    ))

  )
}

export default TableRow